// components
import React from 'react'

import 'core-js/stable/symbol'
import 'core-js/stable/symbol/iterator'
import 'core-js/es/promise'
import 'core-js/es/string/raw'
import 'core-js/es/string/ends-with'
import 'core-js/es/string/starts-with'
import 'core-js/es/string/iterator'
import 'core-js/es/string/replace-all'
import 'core-js/es/array/find'
import 'core-js/es/array/map'
import 'core-js/es/array/reduce'
import 'core-js/es/array/reverse'
import 'core-js/es/array/some'
import 'core-js/es/array/values'
import 'core-js/es/array/concat'
import 'core-js/es/array/every'
import 'core-js/es/array/flat'
import 'core-js/es/array/index-of'
import 'core-js/es/array/find-index'
import 'core-js/es/array/from'
import 'core-js/es/object/keys'
import 'core-js/es/object/assign'
import 'core-js/es/object/to-string'
import 'core-js/es/typed-array'
import 'core-js/es/date'
import 'core-js/es/regexp'

import 'regenerator-runtime/runtime'
import 'custom-event-polyfill'
import loadable from '@loadable/component'
import { constants } from '@common/services'

import hydrate from './hydrate'

const fallback = <div className="loading loading-lg" />

const BazaarVoiceReview = loadable(
  () =>
    import(
      /* webpackChunkName: "BazaarVoiceReview" */ './components/bazaar-voice-review'
    ),
  { fallback }
)
const Cart = loadable(
  () => import(/* webpackChunkName: "Cart" */ './components/cart'),
  { fallback }
)
const Checkout = loadable(
  () => import(/* webpackChunkName: "Checkout" */ './components/checkout'),
  { fallback }
)
const DeviceRegistration = loadable(
  () =>
    import(
      /* webpackChunkName: "DeviceRegistration" */ './components/device-registration'
    ),
  { fallback }
)
const DocomoCallback = loadable(
  () =>
    import(
      /* webpackChunkName: "DocomoCallback" */ './components/docomo-callback'
    ),
  { fallback }
)
const IlumaImmersion = loadable(
  () =>
    import(
      /* webpackChunkName: "IlumaImmersion" */ './components/iluma-immersion'
    ),
  {
    fallback
  }
)
const Login = loadable(
  () => import(/* webpackChunkName: "Login" */ './components/login'),
  { fallback }
)
const Logout = loadable(
  () => import(/* webpackChunkName: "Logout" */ './components/logout'),
  { fallback }
)
const OCR = loadable(
  () => import(/* webpackChunkName: "OCR" */ './components/ocr'),
  { fallback }
)
const OrderConfirmation = loadable(
  () =>
    import(
      /* webpackChunkName: "OrderConfirmation" */ './components/order-confirmation'
    ),
  { fallback }
)
const ProductBundleDetail = loadable(
  () =>
    import(
      /* webpackChunkName: "ProductBundleDetail" */ './components/product-bundle-detail'
    ),
  { fallback }
)
const ProductBundleList = loadable(
  () =>
    import(
      /* webpackChunkName: "ProductBundleList" */ './components/product-bundle-list'
    ),
  { fallback }
)
const ProductDetail = loadable(
  () =>
    import(
      /* webpackChunkName: "ProductDetail" */ './components/product-detail'
    ),
  { fallback }
)
const ProductDetailMulti = loadable(
  () =>
    import(
      /* webpackChunkName: "ProductDetailMulti" */ './components/product-detail-multi'
    ),
  { fallback }
)
const ProductList = loadable(
  () =>
    import(/* webpackChunkName: "ProductList" */ './components/product-list'),
  { fallback }
)
const ProfileAccount = loadable(
  () =>
    import(
      /* webpackChunkName: "ProfileAccount" */ './components/profile-account'
    ),
  { fallback }
)
const ProfileCoupons = loadable(
  () =>
    import(
      /* webpackChunkName: "ProfileCoupons" */ './components/profile-coupons'
    ),
  { fallback }
)
const ProfileDevices = loadable(
  () =>
    import(
      /* webpackChunkName: "ProfileDevices" */ './components/profile-devices'
    ),
  { fallback }
)
const ProfileOrders = loadable(
  () =>
    import(
      /* webpackChunkName: "ProfileOrders" */ './components/profile-orders'
    ),
  { fallback }
)
const ProfileTobaccoDelivery = loadable(
  () =>
    import(
      /* webpackChunkName: "ProfileTobaccoDelivery" */ './components/profile-tobacco-delivery'
    ),
  { fallback }
)
const ProfileGfDashboard = loadable(
  () =>
    import(
      /* webpackChunkName: "ProfileGfDashboard" */ './components/profile-gf-dashboard'
    ),
  { fallback }
)
const Qure = loadable(
  () => import(/* webpackChunkName: "Qure" */ './components/qure'),
  { fallback }
)
const QureUpgradeOffer = loadable(
  () =>
    import(
      /* webpackChunkName: "QureUpgradeOffer" */ './components/qure-upgrade-offer'
    ),
  { fallback }
)
const Registration = loadable(
  () =>
    import(/* webpackChunkName: "Registration" */ './components/registration'),
  { fallback }
)
const Register = loadable(
  () => import(/* webpackChunkName: "Register" */ './components/register'),
  { fallback }
)
const RegistrationConfirm = loadable(
  () =>
    import(
      /* webpackChunkName: "RegistrationConfirm" */ './components/registration-confirm'
    ),
  { fallback }
)
const RegistrationThankYou = loadable(
  () =>
    import(
      /* webpackChunkName: "RegistrationThankYou" */ './components/registration-thank-you'
    ),
  { fallback }
)
const ResetPassword = loadable(
  () =>
    import(
      /* webpackChunkName: "ResetPassword" */ './components/reset-password'
    ),
  { fallback }
)
const SubscriptionProductList = loadable(
  () =>
    import(
      /* webpackChunkName: "SubscriptionProductList" */ './components/subscription-product-list'
    ),
  { fallback }
)

// translations
const CartTranslations = require('./components/cart/cart.json')
const CheckoutTranslations = require('./components/checkout/checkout.json')
const CommonTranslations = require('./common/translations/common.json')
const DeviceRegistrationTranslations = require('./components/device-registration/device-registration.json')
const IlumaImmersionTranslations = require('./components/iluma-immersion/iluma-immersion.json')
const LoginTranslations = require('./components/login/login.json')
const LogoutTranslations = require('./components/logout/logout.json')
const OCRTranslations = require('./components/ocr/ocr.json')
const OrderConfirmationTranslations = require('./components/order-confirmation/order-confirmation.json')
const ProductBundleDetailTranslations = require('./components/product-bundle-detail/product-bundle-detail.json')
const ProductBundleListTranslations = require('./components/product-bundle-list/product-bundle-list.json')
const ProductDetailTranslations = require('./components/product-detail/product-detail.json')
const ProductDetailMultiTranslations = require('./components/product-detail-multi/product-detail-multi.json')
const ProductListTranslations = require('./components/product-list/product-list.json')
const ProfileAccountTranslations = require('./components/profile-account/profile-account.json')
const ProfileCouponsTranslations = require('./components/profile-coupons/profile-coupons.json')
const ProfileDevicesTranslations = require('./components/profile-devices/profile-devices.json')
const ProfileGfDashboardTranslations = require('./components/profile-gf-dashboard/profile-gf-dashboard.json')
const ProfileOrdersTranslations = require('./components/profile-orders/profile-orders.json')
const ProfileTobaccoDeliveryTranslations = require('./components/profile-tobacco-delivery/profile-tobacco-delivery.json')
const QureTranslations = require('./components/qure/qure.json')
const QureUpgradeOfferTranslations = require('./components/qure-upgrade-offer/qure-upgrade-offer.json')
const RegisterTranslations = require('./components/register/register.json')
const RegistrationTranslations = require('./components/registration/registration.json')
const RegistrationConfirmTranslations = require('./components/registration-confirm/registration-confirm.json')
const RegistrationThankYouTranslations = require('./components/registration-thank-you/registration-thank-you.json')
const ResetPasswordTranslations = require('./components/reset-password/reset-password.json')
const SubscriptionProductListTranslations = require('./components/subscription-product-list/subscription-product-list.json')

export default {
  components: {
    BazaarVoiceReview,
    Cart,
    Checkout,
    DeviceRegistration,
    DocomoCallback,
    IlumaImmersion,
    Login,
    Logout,
    OCR,
    OrderConfirmation,
    ProductBundleDetail,
    ProductBundleList,
    ProductDetail,
    ProductDetailMulti,
    ProductList,
    ProfileAccount,
    ProfileCoupons,
    ProfileDevices,
    ProfileGfDashboard,
    ProfileOrders,
    ProfileTobaccoDelivery,
    Qure,
    QureUpgradeOffer,
    Register,
    Registration,
    RegistrationConfirm,
    RegistrationThankYou,
    ResetPassword,
    SubscriptionProductList
  },
  translations: {
    Cart: CartTranslations,
    Checkout: CheckoutTranslations,
    Common: CommonTranslations,
    DeviceRegistration: DeviceRegistrationTranslations,
    IlumaImmersion: IlumaImmersionTranslations,
    Login: LoginTranslations,
    Logout: LogoutTranslations,
    OCR: OCRTranslations,
    OrderConfirmation: OrderConfirmationTranslations,
    ProductBundleDetail: ProductBundleDetailTranslations,
    ProductBundleList: ProductBundleListTranslations,
    ProductDetail: ProductDetailTranslations,
    ProductDetailMulti: ProductDetailMultiTranslations,
    ProductList: ProductListTranslations,
    ProfileAccount: ProfileAccountTranslations,
    ProfileCoupons: ProfileCouponsTranslations,
    ProfileDevices: ProfileDevicesTranslations,
    ProfileGfDashboard: ProfileGfDashboardTranslations,
    ProfileOrders: ProfileOrdersTranslations,
    ProfileTobaccoDelivery: ProfileTobaccoDeliveryTranslations,
    Qure: QureTranslations,
    QureUpgradeOffer: QureUpgradeOfferTranslations,
    Register: RegisterTranslations,
    Registration: RegistrationTranslations,
    RegistrationConfirm: RegistrationConfirmTranslations,
    RegistrationThankYou: RegistrationThankYouTranslations,
    ResetPassword: ResetPasswordTranslations,
    SubscriptionProductList: SubscriptionProductListTranslations
  },
  hydrate,
  version: process.env.VERSION,
  context: 'iqos',
  cdnReactDistUrl: constants.CDN_REACT_DIST_URL
}
